/**
 * Bootstrap file for real-time functionality
 * Sets up Laravel Echo with Soketi WebSocket server
 */

import Echo from 'laravel-echo'
import Pusher from 'pusher-js'

// Make Pusher available globally for Echo
declare global {
  interface Window {
    Pusher: typeof Pusher
    Echo: Echo<any>
  }
}

window.Pusher = Pusher

// Initialize Echo only if we have the required config
const pusherKey = import.meta.env.VITE_PUSHER_APP_KEY
const pusherHost = import.meta.env.VITE_PUSHER_HOST || window.location.hostname

if (pusherKey) {
  window.Echo = new Echo({
    broadcaster: 'pusher',
    key: pusherKey,
    wsHost: pusherHost,
    wsPort: parseInt(import.meta.env.VITE_PUSHER_PORT || '6001'),
    wssPort: parseInt(import.meta.env.VITE_PUSHER_PORT || '6001'),
    forceTLS: import.meta.env.VITE_PUSHER_SCHEME === 'https',
    enabledTransports: ['ws', 'wss'],
    disableStats: true,
    cluster: import.meta.env.VITE_PUSHER_APP_CLUSTER || 'mt1',
    // Privékanalen worden geautoriseerd door de API. Die draait op
    // token-auth (geen sessie/CSRF), dus het Bearer-token moet mee — net
    // als in de axios-client. Het token wordt per aanvraag uit localStorage
    // gelezen en niet bij het aanmaken van Echo vastgezet: bij het opstarten
    // is er nog geen login, en na opnieuw inloggen verandert het.
    authorizer: (channel: { name: string }) => ({
      authorize: (socketId: string, callback: Function) => {
        fetch('/api/broadcasting/auth', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            ...(localStorage.getItem('auth_token')
              ? { Authorization: `Bearer ${localStorage.getItem('auth_token')}` }
              : {}),
          },
          body: JSON.stringify({ socket_id: socketId, channel_name: channel.name }),
        })
          .then((res) => (res.ok ? res.json() : Promise.reject(new Error(`HTTP ${res.status}`))))
          .then((data) => callback(null, data))
          .catch((error) => callback(error, null))
      },
    }),
  })

  // Log connection status in development
  if (import.meta.env.DEV) {
    window.Echo.connector.pusher.connection.bind('connected', () => {
      console.log('✅ WebSocket connected')
    })

    window.Echo.connector.pusher.connection.bind('disconnected', () => {
      console.log('❌ WebSocket disconnected')
    })

    window.Echo.connector.pusher.connection.bind('error', (error: any) => {
      console.error('⚠️ WebSocket error:', error)
    })
  }
}

export {}
